module.exports = __webpack_public_path__ + "375b5c3704ae15988464ee72804e5bd6.jpg";